import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, InputType, LuFormlyBuilder } from 'lu-formly';
import { AdvancedPasswordPolicy } from '../models/advanced-password.models';

export class LuFormlyAdvancedPasswordBuilder extends LuFormlyBuilder {
	protected inputType = InputType.PASSWORD;
	protected type = 'advanced-password' as FieldType;
	private config: AdvancedPasswordPolicy;

	private static readonly DEFAULT_MIN_LENGTH = 6;
	private static readonly DEFAULT_MAX_LENGTH = 100;

	public setConfig(config: AdvancedPasswordPolicy): this {
		this.config = config;
		return this;
	}

	public build(): FormlyFieldConfig {
		const field = super.build();
		// Set layout type to list as default
		if (this.config && !this.config.hasOwnProperty('layoutType')) {
			this.config.layoutType = 'list';
		}

		// Set minLength and maxLength based on the password policy
		const minLength = this.config?.minLength ?? LuFormlyAdvancedPasswordBuilder.DEFAULT_MIN_LENGTH; // Default minLength = 6
		const maxLength = this.config?.maxLength ?? LuFormlyAdvancedPasswordBuilder.DEFAULT_MAX_LENGTH; // Default maxLength = 100

		field.templateOptions = {
			...field.templateOptions,
			config: this.config,
			minLength,
			maxLength
		};
		return field;
	}
}
